import { API_URL } from '../../../app-config/constants';
import { post } from '../request';
const BASE_PATH = `${API_URL}/deleted-users`;

export function getReceipt(id: string, fullName: string, loginName: string): Promise<void> {
    return post(`${BASE_PATH}/${id}/send-confirmation`, { postData: { fullName, loginName } });
}
